import { cloneDeep } from '@apollo/client/utilities';
import { EntityInput, forCreate, forDelete, forUpdate } from '../common/entity';
import { CustomField, CustomFieldEntityType } from '../custom_field';
import { Lot } from './lot';

export class LotInput extends Lot implements EntityInput<Lot> {
  forCreate(): CreateLotInput {
    delete (this as any).authorization;
    return { ...this, customFields: this.customFieldValues() };
  }

  forUpdate(): UpdateLotInput {
    delete (this as any).authorization;
    return UpdateLotInput.from({ ...this, customFields: this.customFieldValues() }, UpdateLotInput);
  }

  forDelete(): DeleteLotInput {
    delete (this as any).authorization;
    return DeleteLotInput.from(this, DeleteLotInput);
  }

  validate(customFields: Map<string, CustomField>) {
    if (!this.number) return false;
    if (!this.productMasterDataId) return false;

    for (const [id, field] of customFields) {
      if (field.entityType === CustomFieldEntityType.lot && field.mandatory && !this.customFields.get(id)?.value) {
        return false;
      }
    }

    return true;
  }

  hasChanges(existing: Lot | undefined) {
    if (!existing) return true;

    if (existing.number !== this.number) return true;

    return false;
  }

  withProductMasterDataId(pmdId: string | null | undefined) {
    this.productMasterDataId = pmdId || '';
    return cloneDeep(this);
  }

  withNumber(number: string) {
    this.number = number;
    return cloneDeep(this);
  }

  withExpirationDate(date?: string) {
    this.expirationDate = date;
    return cloneDeep(this);
  }
}

export class CreateLotInput extends forCreate(LotInput) {}

export class UpdateLotInput extends forUpdate(LotInput) {}

export class DeleteLotInput extends forDelete(LotInput) {}
